import React from 'react';
import {Editor} from '@tinymce/tinymce-react';
import {uploadFile} from "../../requests/fileRequests";
import {editorApiKey} from "../../consts/consts";

export default React.forwardRef((props, ref) => {
    const uploadImage = (blobInfo, success, failure) => {
        uploadFile({
            fileName: (Math.random() * 100000000000000) + blobInfo.filename(),
            base64File: `data:${blobInfo.blob().type};base64,${blobInfo.base64()}`,
            folder: '/training'
        }).then(res => {
            if (res  && res.data && res.data.uploadImage.success) {
                success(res.data.uploadImage.fileUrl.s3_url);
                return;
            }
            failure(`Error: ${res.data.uploadImage.message || 'Unknown error'}`, {remove: true});
        });
    }

    const addVideo = (data) => {
        return (
        `<video width=${data.width}
                height=${data.height}
                ${data.poster ? `poster=${data.poster}` : ''}
                controls=controls>
                <source src=${data.source}
                        ${data.sourcemime ? `type=${data.sourcemime}` : ''}
                />
                ${data.altsource ? 
                    `<source src=${data.altsource}
                             ${data.altsourcemime ? `type=${data.altsourcemime}` : ''}
                    />`
                    :
                    ''
                }
        </video>`
        );
    }

    return (
        <div className={`EditorWrapper ${props.className}`}>
            <Editor
                apiKey={editorApiKey}
                onInit={(evt, editor) => ref.current = editor}
                initialValue={props.content}
                init={{
                    selector: 'textarea',
                    menubar: [
                        'file', 'edit', 'insert',
                    ],
                    plugins: [
                        'advlist autolink autoresize charmap insertdatetime image imagetools fullscreen',
                        'link lists media preview paste searchreplace table',
                    ],
                    toolbar:
                        'undo redo | formatselect | bold italic underline strikethrough | \
                        alignleft aligncenter alignright alignjustify | numlist bullist | outdent indent | \
                        forecolor backcolor removeformat | link image media table charmap | fullscreen',
                    advlist_bullet_styles: 'default,circle,disc,square,lower-alpha,lower-roman',
                    default_link_target: '_blank',
                    link_default_protocol: 'https',
                    images_upload_handler: uploadImage,
                    image_class_list: [
                        { title: 'Left', value: '' },
                        { title: 'Right', value: 'float-right' }
                    ],
                    content_style: 'body .float-right {float: right;}',
                    video_template_callback: addVideo,
                    deprecation_warnings: false
                }}
            />
        </div>
    )
});
